import { useMedia } from 'react-use';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

const CANVAS_MIN_SCREEN_WIDTH = 1000;

/**
 * Returns whether the generative canvas panel should be shown.
 * Requires both the feature flag and a minimum screen width.
 */
export const useIsCanvasVisible = () => {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const isAboveCanvasMinScreen = useMedia(`(min-width: ${CANVAS_MIN_SCREEN_WIDTH}px)`, false);

  return generativeCanvasEnabled && isAboveCanvasMinScreen;
};
